import { applyMiddleware, createStore, combineReducers } from 'redux';
import { apiMiddleware } from 'redux-api-middleware';
import { createLogger } from 'redux-logger';
import { AfspLoginReducers } from '@bit/ui-common.ui-components/afsp';
import WindowReducer from 'reducers/windowReducer';
import SessionReducer from 'reducers/sessionReducer';
import RedirectReducer from './reducers/redirectReducer';
import AppReducer from 'reducers/appReducer';
import { registrationCheckReducer } from 'reducers/registrationCheckReducer';
import { commonData, payment, captcha, help, session } from '@bit/ui-common.ui-components/ss-common-data';
import DodDataReducer from 'reducers/dod/dodDataReducer';
import DodWelcomeReducer from 'reducers/dod/dodWelcomeReducer';
import DodPersonalInformationReducer from 'reducers/dod/dodPersonalInformationReducer';
import DodOfficeAddressReducer from 'reducers/dod/dodOfficeAddressReducer';
import DodCredentialsReducer from 'reducers/dod/dodCredentialsReducer';
import DodSecurityReducer from 'reducers/dod/dodSecurityReducer';
import DodAuthorizationReducer from 'reducers/dod/dodAuthorizationReducer';
import DodReviewReducer from 'reducers/dod/dodReviewReducer';
import FsdoContactReducer from 'reducers/fsdo/fsdoContactReducer';
import FsdoFsdoReducer from 'reducers/fsdo/fsdoFsdoReducer';
import updatePasswordReducer from 'reducers/updatePasswordReducer';
import passwordResetReducer from 'reducers/passwordResetReducer';
import providerReducer from 'reducers/provider/providerReducer';
import candidateRegistrationReducer from './reducers/candidateRegistrationReducer';
import candidateAccountRecoveryReducer from './reducers/candidateAccountRecoveryReducer';
import { environmentPrefixHandler } from '@bit/ui-common.ui-components/ss-middleware';
import { ssFormReducer } from '@bit/ui-common.ui-components/ss-utils';
import statusReducer from './reducers/statusReducer';
import accountReducer from './reducers/accountReducer';

const middlewares = [ environmentPrefixHandler, apiMiddleware ];
if (process.env.NODE_ENV !== 'production') middlewares.push(createLogger());

export default createStore(
    // All reducers.
    combineReducers({
        dod: combineReducers({
            data: DodDataReducer,
            welcome: DodWelcomeReducer,
            personalInformation: DodPersonalInformationReducer,
            officeAddress: DodOfficeAddressReducer,
            credentials: DodCredentialsReducer,
            security: DodSecurityReducer,
            authorization: DodAuthorizationReducer,
            review: DodReviewReducer
        }),
        fsdo: combineReducers({ 
            contact: FsdoContactReducer, 
            fsdoInfo: FsdoFsdoReducer 
        }),
        provider: providerReducer,
        passwordReset: passwordResetReducer,
        passwordUpdate: updatePasswordReducer,
        commonData: commonData.commonDataReducer,
        win: WindowReducer,
        app: AppReducer,
        red: RedirectReducer,
        session: SessionReducer,
        registrationForm: ssFormReducer,
        registrationCheck: registrationCheckReducer,
        paymentData: payment.paymentReducer,
        captcha: captcha.captchaReducer,
        candidate: candidateRegistrationReducer,
        candidateRecovery: candidateAccountRecoveryReducer,
        recoveryForm: ssFormReducer,
        helpData: help.helpReducer,
        login: AfspLoginReducers,
        status: statusReducer,
        account: accountReducer
    }),
    // All middleware.
    applyMiddleware(...middlewares)
);
